module.exports = __webpack_public_path__ + "img/pickUpDefaultBg.fc336412.png";